import React, { useState } from 'react';
import { ResetPasswordData, ResetPasswordVars } from '../gql-types';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import { MIN_PASSWORD_LENGTH } from '../../shared/constants';
import PasswordField from '../../shared/components/PasswordField';
import { PublicGraphQL } from '../gql';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
interface ResetMyPasswordProps {
  onComplete: (success: boolean) => void;
}

const ResetMyPassword = (props: ResetMyPasswordProps) => {
  const [password1, setPassword1] = useState<string>('');
  const [password2, setPassword2] = useState<string>('');
  // `editingPassword2` is used to show/hide the error and helper text.
  // Whenever user is editing `Confirm Password` then hide the error/helper text.
  const [editingPassword2, setEditingPassword2] = useState<boolean>(false);

  const query = useQuery();
  const arePasswordsMatch = () => {
    if (password1 && password2) {
      return password1 === password2;
    }
  };

  const [resetPassword, { loading, error, data }] = useMutation<
    ResetPasswordData,
    ResetPasswordVars
  >(PublicGraphQL.Mutation.RESET_PASSWORD, {
    variables: {
      token: query.get('token'),
      password: password1
    }
  });

  const confirmPasswordErrorMessage = () => {
    return !arePasswordsMatch() && !editingPassword2;
  };

  const hasNoMinimumLength = () => {
    return (
      !!password1 && password1.length < MIN_PASSWORD_LENGTH && !editingPassword2
    );
  };

  const onSubmit = () => {
    resetPassword();
  };

  if (loading) {
    return <p>Resetting your password...</p>;
  }

  if (error) {
    props.onComplete(false);
  }

  if (data?.resetPassword !== undefined) {
    props.onComplete(data.resetPassword);
  }

  return (
    <form onSubmit={onSubmit}>
      <Grid
        container
        justifyContent="center"
        className="login-body"
        direction="column"
        spacing={2}
      >
        <Grid>
          <Typography variant="h5" color="primary" align="center">
            Reset your password
          </Typography>
        </Grid>
        <Grid>
          <PasswordField
            label="New password"
            autofocus
            value={password1}
            onChange={setPassword1}
            onFocus={() => setEditingPassword2(true)}
            onBlur={() => setEditingPassword2(false)}
          />
          <PasswordField
            label="Confirm password"
            autofocus
            disabled={!password1 || hasNoMinimumLength()}
            onBlur={() => setEditingPassword2(false)}
            value={password2}
            onFocus={() => setEditingPassword2(true)}
            onChange={(value: string) => {
              setPassword2(value);
            }}
            error={
              hasNoMinimumLength()
                ? `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`
                : confirmPasswordErrorMessage()
                ? 'Passwords do not match'
                : ''
            }
          />
        </Grid>
        <Grid>
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            name="button"
            value="login"
            style={{ width: '100%' }}
            disabled={!arePasswordsMatch()}
            onClick={onSubmit}
          >
            Reset My Password
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ResetMyPassword;
